import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import PropTypes from "prop-types";

const AssetSearchTags = ({ searchTerm, clearSearchTerm }) => (
  <div className="asset-search-tag-container">
    <div className="asset-search-tag-label">Search results for</div>

    <div className="asset-search-tag-pill">
      {searchTerm}
      <FontAwesomeIcon
        icon={["far", "times-circle"]}
        className="asset-search-tag-icon"
        onClick={clearSearchTerm}
      />
    </div>
  </div>
);

AssetSearchTags.propTypes = {
  searchTerm: PropTypes.string.isRequired,
  clearSearchTerm: PropTypes.func.isRequired,
};

export default AssetSearchTags;



// WEBPACK FOOTER //
// ./src/components/AssetWrapper/AssetDetails/AssetSearchTags/index.js